/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023 Open Assessment Technologies SA ;
 */

/**
 * Definition of a keyboard for a basic calculator.
 * @type {keyboardDefinition}
 */
export default [
    // *** ROW 1 ***
    [
        {
            type: 'button',
            style: 'command',
            command: 'clear',
            label: 'CLEAR',
            size: 3,
            tabindex: 0
        },
        {
            type: 'button',
            style: 'function',
            command: 'sign',
            keys: ['±'],
            label: 'SIGN',
            size: 3,
            tabindex: 1
        },
        {
            type: 'button',
            style: 'function',
            command: 'term',
            keys: ['%'],
            parameter: 'PERCENT',
            label: 'PERCENT',
            size: 3,
            tabindex: 2
        },
        {
            type: 'button',
            style: 'operator',
            command: 'term',
            keys: ['÷', '/'],
            parameter: 'DIV',
            label: 'DIV',
            size: 3,
            tabindex: 3
        }
    ],
    // *** ROW 2 ***
    [
        {
            type: 'button',
            style: 'digit',
            command: 'term',
            keys: ['7'],
            parameter: 'NUM7',
            label: 'NUM7',
            size: 3,
            tabindex: 16
        },
        {
            type: 'button',
            style: 'digit',
            command: 'term',
            keys: ['8'],
            parameter: 'NUM8',
            label: 'NUM8',
            size: 3,
            tabindex: 17
        },
        {
            type: 'button',
            style: 'digit',
            command: 'term',
            keys: ['9'],
            parameter: 'NUM9',
            label: 'NUM9',
            size: 3,
            tabindex: 18
        },
        {
            type: 'button',
            style: 'operator',
            command: 'term',
            keys: ['×', '*'],
            parameter: 'MUL',
            label: 'MUL',
            size: 3,
            tabindex: 4
        }
    ],
    // *** ROW 3 ***
    [
        {
            type: 'button',
            style: 'digit',
            command: 'term',
            keys: ['4'],
            parameter: 'NUM4',
            label: 'NUM4',
            size: 3,
            tabindex: 13
        },
        {
            type: 'button',
            style: 'digit',
            command: 'term',
            keys: ['5'],
            parameter: 'NUM5',
            label: 'NUM5',
            size: 3,
            tabindex: 14
        },
        {
            type: 'button',
            style: 'digit',
            command: 'term',
            keys: ['6'],
            parameter: 'NUM6',
            label: 'NUM6',
            size: 3,
            tabindex: 15
        },
        {
            type: 'button',
            style: 'operator',
            command: 'term',
            keys: ['-'],
            parameter: 'SUB',
            label: 'SUB',
            size: 3,
            tabindex: 5
        }
    ],
    // *** ROW 4 ***
    [
        {
            type: 'button',
            style: 'digit',
            command: 'term',
            keys: ['1'],
            parameter: 'NUM1',
            label: 'NUM1',
            size: 3,
            tabindex: 10
        },
        {
            type: 'button',
            style: 'digit',
            command: 'term',
            keys: ['2'],
            parameter: 'NUM2',
            label: 'NUM2',
            size: 3,
            tabindex: 11
        },
        {
            type: 'button',
            style: 'digit',
            command: 'term',
            keys: ['3'],
            parameter: 'NUM3',
            label: 'NUM3',
            size: 3,
            tabindex: 12
        },
        {
            type: 'button',
            style: 'operator',
            command: 'term',
            keys: ['+'],
            parameter: 'ADD',
            label: 'ADD',
            size: 3,
            tabindex: 6
        }
    ],
    // *** ROW 5 ***
    [
        {
            type: 'button',
            style: 'digit',
            command: 'term',
            keys: ['0'],
            parameter: 'NUM0',
            label: 'NUM0',
            size: 3,
            tabindex: 9
        },
        {
            type: 'button',
            style: 'digit',
            command: 'term',
            keys: ['.'],
            parameter: 'DOT',
            label: 'DOT',
            size: 3,
            tabindex: 8
        },
        {
            type: 'button',
            style: 'operator',
            command: 'execute',
            keys: ['=', 'enter'],
            label: 'EXECUTE',
            size: 6,
            tabindex: 7
        }
    ]
];
